import { SaleApprovalChecklistItems } from '../sdk/sdk';

/**
 * Helper function to check if a specific flag is set
 */
export function hasFlag(
  value: SaleApprovalChecklistItems,
  flag: SaleApprovalChecklistItems
): boolean {
  return (value & flag) === flag;
}

/**
 * Helper function to set a specific flag
 */
export function setFlag(
  value: SaleApprovalChecklistItems,
  flag: SaleApprovalChecklistItems
): SaleApprovalChecklistItems {
  return value | flag;
}

/**
 * Helper function to clear a specific flag
 */
export function clearFlag(
  value: SaleApprovalChecklistItems,
  flag: SaleApprovalChecklistItems
): SaleApprovalChecklistItems {
  return value & ~flag;
}

/**
 * Helper function to toggle a specific flag
 */
export function toggleFlag(
  value: SaleApprovalChecklistItems,
  flag: SaleApprovalChecklistItems
): SaleApprovalChecklistItems {
  return value ^ flag;
}

/**
 * Get all available checklist items as an array
 */
export function getAllChecklistItems(): {
  value: SaleApprovalChecklistItems;
  label: string;
}[] {
  return [
    { value: SaleApprovalChecklistItems.TableConsult, label: 'Table Consult' },
    { value: SaleApprovalChecklistItems.FlightPlan, label: 'Flight Plan' },
    { value: SaleApprovalChecklistItems.Pictures, label: 'Pictures' },
    { value: SaleApprovalChecklistItems.Sketch, label: 'Sketch' },
    { value: SaleApprovalChecklistItems.Contract, label: 'Contract' },
    {
      value: SaleApprovalChecklistItems.FinancingDocumentation,
      label: 'Financing Documentation',
    },
    {
      value: SaleApprovalChecklistItems.PermitAndEngineeringForms,
      label: 'Permit and Engineering Forms',
    },
    { value: SaleApprovalChecklistItems.Notes, label: 'Notes' },
  ];
}
